/**
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Get current user's list of orders
export const ORDERS_GET_REQUESTED = "ORDERS_GET_REQUESTED";
export const ORDERS_GET_SUCCESS = "ORDERS_GET_SUCCESS";
export const ORDERS_GET_ERROR = "ORDERS_GET_ERROR";
export const ADDRESS_DETAILS_GET_REQUESTED = "ADDRESS_DETAILS_GET_REQUESTED";
export const ADDRESS_DETAILS_GET_SUCCESS = "ADDRESS_DETAILS_GET_SUCCESS";
export const ADDRESS_DETAILS_GET_ERROR = "ADDRESS_DETAILS_GET_ERROR";
export const ACCOUNT_DETAILS_PUT_REQUESTED = "ACCOUNT_DETAILS_PUT_REQUESTED";
export const ACCOUNT_DETAILS_PUT_SUCCESS = "ACCOUNT_DETAILS_PUT_SUCCESS";
export const ACCOUNT_DETAILS_PUT_ERROR = "ACCOUNT_DETAILS_PUT_ERROR";
export const ACCOUNT_DELETE_REQUESTED = "ACCOUNT_DELETE_REQUESTED";
export const ACCOUNT_DELETE_SUCCESS = "ACCOUNT_DELETE_SUCCESS";
export const ACCOUNT_DELETE_ERROR = "ACCOUNT_DELETE_ERROR";
